import type { PropsWithChildren } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface BlockProps {
  className?: string;
}

export const Block = ({
  children,
  className,
}: PropsWithChildren<BlockProps>) => (
  <div
    className={classNames(
      "bg-primary relative flex h-[120px] w-[302px] justify-center rounded-2xl shadow-sm",
      className,
    )}
  >
    {children}
  </div>
);
